module.exports = __webpack_public_path__ + "static/media/magogo-logo.db284826.png";